import React from 'react';
import {
  ButtonToolbar,
  FormControl,
  InputGroup,
  OverlayTrigger,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from 'react-bootstrap';
import { IoIosHelpCircle } from 'react-icons/io';
import {
  PriceRuleOffsetType,
  PriceRuleSource,
} from '@upstart/harmony/lib/constants';

export const renderHelpToolTip = (id: string, message: string) => (
  <OverlayTrigger
    placement="bottom"
    delayHide={300}
    overlay={<Tooltip id={id}>{message}</Tooltip>}
  >
    <div className="pricing-matrix-help">
      <IoIosHelpCircle size={20} className="help-icon" />
    </div>
  </OverlayTrigger>
);

export const renderPriceRuleSourceSelector = (
  value: PriceRuleSource,
  setValue: (value: PriceRuleSource) => void,
) => (
  <ButtonToolbar>
    <ToggleButtonGroup
      type="radio"
      name="priceType"
      value={value}
      onChange={setValue}
    >
      <ToggleButton value={PriceRuleSource.INVOICE}>Invoice</ToggleButton>
      <ToggleButton value={PriceRuleSource.FEED_PRICE}>Feed Price</ToggleButton>
    </ToggleButtonGroup>
  </ButtonToolbar>
);

export const renderOffsetInput = (
  type: PriceRuleOffsetType,
  offset: number | undefined,
  setType: (type: PriceRuleOffsetType) => void,
  setOffset: (offset: number | undefined) => void,
) => (
  <InputGroup className="offset-input">
    <InputGroup.Addon>
      <FormControl
        componentClass="select"
        placeholder="select"
        value={type}
        onChange={event =>
          setType(
            (event.target as HTMLInputElement).value as PriceRuleOffsetType,
          )
        }
      >
        <option value={PriceRuleOffsetType.ADD}>+</option>
        <option value={PriceRuleOffsetType.SUBTRACT}>-</option>
        <option value={PriceRuleOffsetType.ADD_PERCENT}>+ %</option>
        <option value={PriceRuleOffsetType.SUBTRACT_PERCENT}>- %</option>
      </FormControl>
    </InputGroup.Addon>
    <FormControl
      type="number"
      placeholder="0"
      value={offset ?? undefined}
      onChange={event =>
        setOffset(
          parseInt(
            (event.target as HTMLInputElement).value.replace(/-/g, ''),
            10,
          ),
        )
      }
    />
  </InputGroup>
);

export function stopPropagation(
  event: React.MouseEvent<HTMLDivElement, MouseEvent>,
) {
  event.stopPropagation();
}
